import React from 'react'
import { Paper, Box } from '@mui/material'

/**
 * Barra de botões: Excel, Nova Empresa, etc. Botões no tamanho padrão.
 * Grupo centralizado na altura da barra via position + transform.
 * Wrapper com altura fixa garante o mesmo comportamento em todas as telas (Empresas, Grupos, Manutenção, etc.).
 * Alinha com a sidebar (left/width) para evitar erro de tamanho/corte.
 */
import { ACTION_BAR_HEIGHT_PX, HEADER_HEIGHT_PX } from '../constants/layout'
import { useLayout } from '../contexts/LayoutContext'

const SIDEBAR_OPEN_PX = 256
const SIDEBAR_CLOSED_PX = 64

const ActionBar: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { sidebarOpen } = useLayout()
  const sidebarWidthPx = sidebarOpen ? SIDEBAR_OPEN_PX : SIDEBAR_CLOSED_PX

  // Se não houver children, retorna null (não renderiza a barra)
  if (!children) return null;

  return (
  <Box
    sx={{
      flexShrink: 0,
      height: ACTION_BAR_HEIGHT_PX,
      position: 'fixed',
      top: HEADER_HEIGHT_PX,
      left: sidebarWidthPx,
      width: `calc(100% - ${sidebarWidthPx}px)`,
      zIndex: 20,
      transition: 'left 0.3s, width 0.3s',
      backgroundColor: 'background.default',
      mt: 0,
      mb: 0,
    }}
  >
    <Paper
      component="section"
      aria-label="Barra de botões"
      elevation={2}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        px: { xs: 1.5, sm: 2.5 },
        pr: { xs: 2, sm: 3 },
        borderRadius: 0,
        borderBottom: '1px solid', // Apenas borda inferior
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderColor: 'divider',
        bgcolor: (theme) =>
          theme.palette.mode === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.background.paper,
        '& .MuiButton-root': {
          margin: 0,
        },
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {children}
      </Box>
    </Paper>
  </Box>
)}

export default ActionBar
